import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import styles from './DefaultTab.module.scss';

const DefaultTab = ({
  className,
  active,
  disabled,
  label,
  onClick,
  textClassName,
}: {
  className: any;
  active: any;
  disabled: any;
  label: any;
  onClick: any;
  textClassName: any;
}) => (
  <div
    className={cn(
      styles.tab,
      { [styles.tabActive]: active, [styles.tabDisabled]: disabled },
      className,
    )}
    onClick={() => {
      if (disabled) {
        return;
      }
      onClick(label);
    }}
  >
    <Typography
      className={cn(styles.text, textClassName)}
      variant="body2"
      weight="medium"
      mode="compact"
    >
      {label}
    </Typography>
  </div>
);

export default React.memo(DefaultTab) as any;
